module.exports = __webpack_public_path__ + "img/pencil-underline.4f754f3d.svg";